import RestApiModel from "@/api/Model/RestApiModel";

class Audit extends RestApiModel {
  static getResourceEndpoint() {
    return '/audits';
  }
}

export default Audit;
